import type BoundingBox from "../types/BoundingBox";

export default function bbIntersect(a: BoundingBox, b: BoundingBox): boolean {
  return (
    Math.abs(a.x - b.x) * 2 < a.width + b.width &&
    Math.abs(a.y - b.y) * 2 < a.height + b.height
  );
}
